
import {css} from "@benev/slate"
export default css`

[part="copybox"] {
	display: flex;
	flex-wrap: wrap;
	font-family: monospace;
}

[part="weak"] {
	opacity: 0.5;
}

`

